export default "__VITE_ASSET__DjFakbzg__"